import useShortcut from 'common/utilities/hooks/useShortcut/useShortcut';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { Sequence, SequenceAlign } from 'sequenceAnalyser/api/sequenceAnalyserApiClient';
import type { HandleAlignedSequencesChange } from 'sequenceAnalyser/components/SequenceAnalyser/SequenceAnalyser';
import type { SequenceSelection } from 'sequenceAnalyser/utilities/selection/selection';
import { insertGapsIntoSelectedSequences } from 'sequenceAnalyser/utilities/selectionActions/selectionActions';

function useShortcutInsertGap(
  alignedSequences: SequenceAlign[],
  sequences: Sequence[],
  onAlignedSequencesChange: HandleAlignedSequencesChange,
) {
  const insertGapTrigger = useShortcut(' ', false, { debounceTime: 50 });
  const selection = useSelector((state: ApplicationState) => state.sequenceAnalyser.selection);

  useEffect(() => {
    if (
      insertGapTrigger
      && selection
      && selection.positionStart !== undefined && selection.positionEnd !== undefined
      && selection.positionStart === selection.positionEnd
    ) {
      const { updatedAlignedSequences, updatedSequences } = insertGapsIntoSelectedSequences(
        selection,
        alignedSequences,
        sequences,
        selection.positionEnd + 1,
        '.',
      );

      const newSelection: SequenceSelection = {
        ...selection,
        positionStart: selection.positionStart + 1,
        positionEnd: selection.positionEnd + 1,
      };

      onAlignedSequencesChange(updatedAlignedSequences, updatedSequences, newSelection);
    }
  }, [alignedSequences, insertGapTrigger, onAlignedSequencesChange, selection, sequences]);
}

export default useShortcutInsertGap;
